module.exports = __webpack_public_path__ + "img/main.82737e76.jpg";